import React, { useState, useEffect } from 'react';
import GetUrls from 'ts/enums/Url'
import { http } from 'utils'
import toast from 'react-hot-toast';
import { Button, Input, TextArea } from 'components/ui'
import { SpinnerIcon } from 'components/svg'
import { useTrader } from 'context/TraderTypeContext';
import useAuthStore from 'store/auth'
import BalanceEnquiryPreview from 'components/BalanceEnquiryPreview';

interface StoreData {
  balanceTitle: string;
  balanceText: any;
}

const BalanceEnquiryLayoutPage = () => {
  const Url = GetUrls();
  const user = useAuthStore((state) => state.user);
  const { traderId } = useTrader();
  const [isLoading, setLoading] = useState(false);
  const [errorFile, setErrorFile] = useState<string | null>(null);
  const [data, setData] = useState<StoreData | null>(null);

  const fetchStoreData = async (): Promise<StoreData> => {
    try {
        const response = await http.get<StoreData>(Url.getReceiptFormat(traderId))
        return response.data;
    } catch (error) {
      console.error('Error fetching data:', error);
      throw error;
    }
  };

  useEffect(() => {
    const loadData = async () => {
      setLoading(true);
      try {
        const storeData = await fetchStoreData();
        setData(storeData);
      } catch (error) {
        setErrorFile('Failed to fetch store data.');
      } finally {
        setLoading(false);
      }
    };
    if (traderId || user?.traders.length === 0) {
      loadData();
    }
  }, [traderId]); 

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    if (data) {
      setData({
        ...data,
        [name]: value,
      });
    }
  };

  const handleTextAreaChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    if (data) {
      setData({
        ...data,
        [name]: value,
      });
    }
  };
  
  const handleSubmit = async () => {
    setLoading(true);
    try {
      const mainresp = await http.request({
        url: Url.updateReceiptFormat,
        method: 'PUT',
        data: {
          "programId": Number(user.programId),
          "traderId": Number(user.traders.length !== 0 ? traderId : user.traderId),
          "balanceTitle": data?.balanceTitle,
          "balanceText": data?.balanceText,
        }
      });
      if (mainresp.status !== 200) {
        toast.error('Failed to update receipt layout');
        throw new Error('Failed to update receipt layout');
      }
      toast.success('Successfully saved');
    } catch (error) {
      toast.error(`Failed to save. ${(error as any)?.message || 'An unknown error occurred'}`);
    } finally {
      setLoading(false);
    }
  };
  
  return (
    <div className="px-8 py-6 rounded bg-gray-50 shadow-xl mt-4 mx-4">
      {
      <div className="flex">
        <div className='flex flex-col justify-between w-full'>
          <div>
            <h1 className="text-lg font-bold">Edit Balance Enquiry Layout</h1>
            <h1 className="text-sm text-gray-400">Edit your Balance Enquiry layout</h1>
            <div className='shrink-0 bg-border h-025 w-full my-5'></div>
            <div className='flex flex-col justify-between'>
                <Input
                  disabled={isLoading}
                  label="Title"
                  placeholder="balanceTitle"
                  name="balanceTitle"
                  value={data?.balanceTitle || 'Balance Title'}
                  maxLength={60}
                  onChange={handleInputChange}
                />
                <TextArea
                disabled={isLoading}
                label="Balance Text"
                placeholder="Enter balance text"
                name="balanceText"
                value={data?.balanceText || ''}
                onChange={handleTextAreaChange}
              />
           </div>
            </div>
            <Button
              isLoading={isLoading}
              className={`w-40 mt-4 z-20 relative ${isLoading && 'cursor-default'}`}
              onClick={handleSubmit}
              disabled={isLoading}
            >
            {isLoading ? <SpinnerIcon /> : 'Submit'}
          </Button>
        </div>
        <BalanceEnquiryPreview 
          isLoading={isLoading}
          balanceTitle={data?.balanceTitle || 'balanceTitle'}
          balanceText={data?.balanceText || 'Balance text goes here'}
        />
      </div>
      }
    </div>
    )
}

export default BalanceEnquiryLayoutPage
